// recorder.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RecorderService {
  private mediaRecorder!: MediaRecorder;
  private audioChunks = [];

  startRecording() {
    navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
      this.mediaRecorder = new MediaRecorder(stream);
      this.mediaRecorder.ondataavailable = (event) => {
        this.audioChunks.push(event.data as never);
      };
      if(!this.mediaRecorder) {
        alert('無法開始錄音');
        return;
      }else
        this.mediaRecorder.start();
    });
  }

  stopRecording(): Promise<Blob> {
    return new Promise((resolve) => {
      if(!this.mediaRecorder) {
        alert('無法開始錄音');
        resolve(new Blob());
        return;
      }
      this.mediaRecorder.onstop = () => {
        const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
        this.audioChunks = [];
        resolve(audioBlob);
      };
      this.mediaRecorder.stop();
    });
  }
}
